import React from "react";

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";

import { FieldQueryInternalControl } from "../../field-query.types";

import "./controls.styles.scss";

export type FieldQueryControlsProps = {
  controls: Array<FieldQueryInternalControl>;
};

export const Controls: React.FC<FieldQueryControlsProps> = ({ controls }) => {
  return (
    <div className="FieldQueryControls">
      {controls.map((x, i) => {
        const tooltip = x.tooltip || "";
        return (
          <div
            key={i}
            className="FieldQueryControls__btn-wrapper"
            title={tooltip}
          >
            <Button
              {...getTestAttributes("field-query-controls", x.description, "button")}
              className="FieldQueryControls__btn"
              onClick={x.handler}
              disabled={x.disabled}
              style={{ pointerEvents: x.disabled ? "none" : "auto" }}
            >
              <img className="FieldQueryControls__icon" src={x.iconSrc} />
            </Button>
          </div>
        );
      })}
    </div>
  );
};
